import { useState, useEffect } from 'react'

const DESKTOP_BREAKPOINT = 768

/**
 * useResponsiveLayout - Returns layout mode based on viewport width
 * Single source of truth for mobile vs desktop layout decisions.
 * Uses matchMedia for reliable responsive detection with change listener.
 *
 * @returns {{ isDesktop: boolean }}
 */
export function useResponsiveLayout() {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== 'undefined' && window.innerWidth >= DESKTOP_BREAKPOINT
  )

  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`)
    const handler = (e) => setIsDesktop(e.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])

  return { isDesktop }
}
